import axiosInstance from "./AxiosInstance" 
import defaultAvatar from "../../src/assets/images/placeholder.jpg" 

export function getPatientList(isMultiValue) {
  return axiosInstance.post("/admin/PatientQueueList", {
    is_multi: isMultiValue,
    without_auth: "YES", // Key part
  })
}

export function formatPatients(data) {
  if (!data || !Array.isArray(data)) return [];

  return data.map((item) => {
    const fullName = `${item.first_name || ""} ${item.middile_name || ""} ${item.last_name || ""}`.trim();

    const contact =
      item.whatsapp_contact_no || item.additional_contact_no || "";

    // ✅ FIX: define partnerName properly
    const partnerName = item.partnerDetails?.first_name
      ? `${item.partnerDetails.first_name} ${item.partnerDetails.last_name || ""}`.trim()
      : "";

    return {
      queue_id: item.queue_id,
      patient_id: item.patient_id,
      name: fullName || "N/A",

      avatar: item.patient_photo || defaultAvatar,
      patient_photo: item.patient_photo || defaultAvatar,

      time_slot: item.time_slot || "-",
      token_no: String(item.token_no || "0").padStart(2, "0"),

      first_name: item.first_name,
      last_name: item.last_name,

      occupation: item.occupation,
      created_at: item.created_at,
      status: item.patient_marked || "",

      contact: contact,
      showCollectButton: item.is_payment !== "Yes",

      weight: item.weight,
      height: item.height,
      gender: item.gender,
      whatsapp_contact_no: item.whatsapp_contact_no,

      age: calculateAge(item.date_of_birth),

      doctor_id: item.doctor_id,
      doctor_name: item.doctor_name,

      systolic_bp: item.systolic_bp ?? null,
      diastolic_bp: item.diastolic_bp ?? null,
      bmi: item.bmi ?? null,
      pulse_rate: item.pluse_rate ?? null,

      temperature: item.temperature ?? null,
      Oxygen_Saturation: item.Oxygen_Saturation ?? null,
      blood_glucose_level: item.blood_glucose_level ?? null,
      Allergies: item.Allergies ?? null,
      Reports_Upload: item.Reports_Upload ?? null,

      diseases: item.diseases || "",
      is_firsttime_visitor: item.is_firsttime_visitor === "Yes",

      // ✅ NOW WORKS
      partner_name: partnerName,
      partner_id: item.partnerDetails?.patient_id || null,
      partnerDetails: item.partnerDetails || null,
    };
  });

  function calculateAge(dob) {
    if (!dob || dob === "0000-00-00") return null;

    const birthDate = new Date(dob);
    if (isNaN(birthDate)) return null;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }
}

// export function groupPatientsByDoctor(doctorsDataArray) {
//   if (!doctorsDataArray || !Array.isArray(doctorsDataArray)) return []

//   return doctorsDataArray
//     .map((doctor) => {
//       // Safely get patients array, default to empty array if undefined or not an array
//       const patients = Array.isArray(doctor.patients) ? doctor.patients : []

//       const currentPatientRaw = patients.find((p) => p.patient_marked === "Current")
//       const upcomingPatientsRaw = patients.filter((p) => p.patient_marked !== "Current")

//       const currentPatient = currentPatientRaw ? formatPatients([currentPatientRaw])[0] : null
//       const queue = formatPatients(upcomingPatientsRaw)

//       return {
//         doctor_id: doctor.doctor_id,
//         doctor_name: doctor.doctor_name,
//         is_pause: doctor.is_pause, // 
//         currentPatient: currentPatient,
//         queue: queue,
//       }
//     })
//     .filter((doctor) => doctor.currentPatient || doctor.queue.length > 0) 
// }
export function groupPatientsByDoctor(doctorsDataArray) {
  if (!doctorsDataArray || !Array.isArray(doctorsDataArray)) return []

  return doctorsDataArray
    .map((doctor) => {
      const patients = Array.isArray(doctor.patients) ? doctor.patients : []

      // 🔹 Find Current
      const currentPatientRaw = patients.find(
        (p) => p.patient_marked === "Current"
      )

      // 🔹 Find Next
      const nextPatientRaw = patients.find(
        (p) => p.patient_marked === "Next"
      )

      // 🔹 Remaining → Queue (only Waiting)
      const upcomingPatientsRaw = patients.filter(
        (p) =>
          p.patient_marked !== "Current" &&
          p.patient_marked !== "Next"
      )

      const currentPatient = currentPatientRaw
        ? formatPatients([currentPatientRaw])[0]
        : null

      const nextPatient = nextPatientRaw
        ? formatPatients([nextPatientRaw])[0]
        : null

      const queue = formatPatients(upcomingPatientsRaw)

      return {
        doctor_id: doctor.doctor_id,
        doctor_name: doctor.doctor_name,
        is_pause: doctor.is_pause,
        currentPatient,
        nextPatient,   // ✅ NEW
        queue,
      }
    })
    .filter(
      (doctor) =>
        doctor.currentPatient ||
        doctor.nextPatient ||
        doctor.queue.length > 0
    )
}